import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { connect, sendSimulation } from "../../utils/socket";
import { Select, Button, Slider, Switch } from "antd";
import { useNavigate } from "react-router-dom";
import "./Simulator.css";
const { Option } = Select;

function Simulator({ dashboardStore, authStore, orgDashboardStore }) {
  const [running, setRunning] = useState(false);

  const [enableHeartRate, setEnableHeartRate] = useState(true);
  const [heartRateSlider, setHeartRateSlider] = useState([70, 95]);

  const [enableHrv, setEnableHrv] = useState(true);
  const [hrvSlider, setHrvSlider] = useState([50, 80]);

  const [enableMotion, setEnableMotion] = useState(false);
  const [motionSlider, setMotionSlider] = useState([0, 0.5]);

  const stop = () => {
    setRunning(false);
  };

  const start = () => {
    setRunning(true);
  };

  useEffect(() => {
    connect();
  }, []);

  function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }

  useEffect(() => {
    const i_id = setInterval(() => {
      if (!running) {
        return;
      }
      const heartRate = Math.floor(
        getRandomArbitrary(heartRateSlider[0], heartRateSlider[1])
      );
      if (enableHeartRate) {
        const timestamp = new Date().toISOString();
        const payload = {
          user_code: "simulated",
          device_id: "ab1634cc-4d65-48e7-9c18-624dc316ceac",
          heartRates: [
            { rrIntervals: [], heartRate: heartRate, timestamp: timestamp },
          ],
        };
        sendSimulation(payload);
      }
      if (enableMotion) {
        const motion = getRandomArbitrary(motionSlider[0], motionSlider[1]);
        const timestamp = new Date().toISOString();
        const payload = {
          user_code: "simulated",
          device_id: "ab1634cc-4d65-48e7-9c18-624dc316ceac",
          accelerometers: [
            { abs_total: { max: motion }, timestamp: timestamp },
          ],
          heartRates: [{ rrIntervals: [], heartRate, timestamp: timestamp }],
        };
        sendSimulation(payload);
      }
      if (enableHrv) {
        const sdnn = getRandomArbitrary(hrvSlider[0], hrvSlider[1]);
        const timestamp = new Date().toISOString();
        const payload = {
          user_code: "simulated",
          metrics: [{ userid: "simulated", timepoint: timestamp, sdnn: sdnn }],
        };
        sendSimulation(payload);
      }
    }, 1000);
    return () => {
      clearInterval(i_id);
    };
  }, [
    running,
    heartRateSlider,
    motionSlider,
    hrvSlider,
    enableHeartRate,
    enableHrv,
    enableMotion,
  ]);

  const timeoutfunc = () => {};

  return (
    <>
      <div className="Simulator">
        <h1>Simulator</h1>
        <h2 style={{ marginTop: "40px" }}>
          Heart rate{" "}
          <Switch
            size="small"
            checked={enableHeartRate}
            onChange={setEnableHeartRate}
          />
        </h2>
        Range: {heartRateSlider[0]} to {heartRateSlider[1]}
        <Slider
          range
          min={0}
          max={200}
          defaultValue={heartRateSlider}
          onChange={setHeartRateSlider}
          disabled={!enableHeartRate}
        />
        <h2 style={{ marginTop: "40px" }}>
          Hrv{" "}
          <Switch size="small" checked={enableHrv} onChange={setEnableHrv} />
        </h2>
        Range: {hrvSlider[0]} to {hrvSlider[1]}
        <Slider
          range
          min={0}
          max={200}
          defaultValue={hrvSlider}
          onChange={setHrvSlider}
          disabled={!enableHrv}
        />
        <h2 style={{ marginTop: "40px" }}>
          Motion{" "}
          <Switch
            size="small"
            checked={enableMotion}
            onChange={setEnableMotion}
          />
        </h2>
        Range: {motionSlider[0]} to {motionSlider[1]}
        <Slider
          range
          min={0}
          max={200}
          step={0.5}
          defaultValue={motionSlider}
          onChange={setMotionSlider}
          disabled={!enableMotion}
        />
        <div style={{ marginTop: "40px" }}>
          <Button size="large" disabled={running} onClick={start}>
            Start
          </Button>
          <Button size="large" disabled={!running} onClick={stop}>
            Stop
          </Button>
        </div>
      </div>
    </>
  );
}

export default observer(Simulator);
